/**
 * Las funciones del restaurante que se encienden en Ajustes › Funciones
 * (2026-10-27): reservaciones y «sin tomate».
 *
 * La misma regla que el servidor (`reservaciones_activas`,
 * `quitar_ingredientes_activo`) y que Producción: sin nada guardado, encendidas
 * solo en un restaurante. Lo pidió el propietario («que estén activadas por
 * defecto») sin tener que tocar los ajustes de ningún negocio.
 */

import type { IngredienteQuitado, ItemListRow, QuitableDeLista, TenantSettings } from "./types";

type Ajustes = Partial<TenantSettings> | null | undefined;

function encendidaEnRestaurante(guardado: boolean | undefined, ajustes: Ajustes): boolean {
  if (guardado != null) return guardado;
  return ajustes?.modo_operacion === "restaurante";
}

export function reservacionesActivas(ajustes: Ajustes): boolean {
  return encendidaEnRestaurante(ajustes?.reservaciones_enabled, ajustes);
}

export function quitarIngredientesActivo(ajustes: Ajustes): boolean {
  return encendidaEnRestaurante(ajustes?.quitar_ingredientes_enabled, ajustes);
}

/**
 * Lo que se puede quitar de un plato EN ESA VARIACIÓN: lo de todas más lo
 * suyo. El filete de pollo se quita de la de Pollo, no de la de Carne (el
 * servidor lo comprueba igual, `_resolver_sin`).
 */
export function quitablesDelPlato(
  item: Pick<ItemListRow, "quitables"> | null | undefined,
  variacionId: string | null | undefined,
): QuitableDeLista[] {
  return (item?.quitables ?? []).filter(
    (q) => q.variacion_id == null || q.variacion_id === variacionId,
  );
}

/**
 * «Sin Tomate · Sin Cebolla», para la cuenta y el carrito.
 *
 * Con el nombre tal como está en el catálogo: pasarlo a minúsculas rompería
 * los que llevan nombre propio («Salsa de la Casa»).
 */
export function textoDeSin(sin: readonly Pick<IngredienteQuitado, "nombre">[]): string {
  return sin.map((q) => `Sin ${q.nombre}`).join(" · ");
}
